// extracted by mini-css-extract-plugin
export default {"repo":"Repo_repo__d3TEq","fadeIn":"Repo_fadeIn__fYcVa"};